<template>
  <div class="flex flex-col items-center rounded-md">
    <div
      v-if="event.properties?.nb_people"
      class="flex items-center gap-x-2 rounded border px-1.5 py-0.5 text-xs font-semibold"
    >
      <div
        v-if="nbPeopleAssigned !== event.properties.nb_people"
        class="relative flex h-2.5 w-2.5"
        data-tint="danger"
      >
        <span
          class="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"
        >
        </span>
        <span class="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary">
        </span>
      </div>
      <FontAwesomeIcon :icon="['fal', 'users']" />
      <span class="capitalize-first">{{
        nbPeopleAssigned + '/' + event.properties.nb_people
      }}</span>
    </div>
    <div
      v-if="event.properties[`${eventTypes[event.type]}_hearse`]"
      class="flex items-center gap-x-1.5 px-1 py-0.5 text-xs text-slate-700"
    >
      <FontAwesomeIcon :icon="['fal', 'car']" />
      <span class="capitalize-first">
        {{ $t('attributes.hearse') }}
      </span>
      <span>{{
        event.properties[`${eventTypes[event.type]}_hearse_count`]
      }}</span>
    </div>
    <div
      v-if="event.properties[`${eventTypes[event.type]}_flower_hearse`]"
      class="flex items-center gap-x-1.5 px-1 py-0.5 text-xs text-slate-700"
    >
      <FontAwesomeIcon :icon="['fas', 'flower']" />
      <span class="capitalize-first">{{ $t('attributes.flower_hearse') }}</span>
      <span>{{
        event.properties[`${eventTypes[event.type]}_flower_hearse_count`]
      }}</span>
    </div>
    <div
      v-if="event.properties[`${eventTypes[event.type]}_van`]"
      class="flex items-center gap-x-1.5 px-1 py-0.5 text-xs text-slate-700"
    >
      <FontAwesomeIcon :icon="['fal', 'van-shuttle']" />
      <span class="capitalize-first">
        {{ $t('attributes.van') }}
      </span>
      <span>
        {{ event.properties[`${eventTypes[event.type]}_van_count`] }}
      </span>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import eventType from '@/assets/enums/events/EventType'

export default {
  name: 'EventCardExtraInfo',
  components: { FontAwesomeIcon },
  props: {
    event: {
      type: Object,
      required: true
    },
    nbPeopleAssigned: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      eventTypes: {
        CER: 'ceremony',
        CRE: 'cremation',
        BUR: 'burial'
      }
    }
  }
}
</script>

<style scoped></style>
